<template>
	<div class="input">
		<select v-model.string="inputVal" class="form-control form-control-sm">
			<option value="" disabled selected>{{placeholder}}</option>
			<option v-for="(subject, index) in options" :v-key="index" :value="subject">{{subject}}</option>
		</select>
		<inputAlert :error="error"/>
	</div>
</template>

<script>
import inputAlert from './input-alert'
export default {
	components:{
		inputAlert,
	},
	props:{
		change: Function,
		error: String,
		options: Array,
		placeholder: String,
		value: String,
	},
	computed:{
		inputClass: function(){
			return `form-control form-control-sm ${this.error? 'is-invalid': ''}`
		},

		// the following is needed to allow the parent to bind to this value
		// https://stackoverflow.com/questions/47311936/v-model-and-child-components
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        if (this.change) this.change();
      }
    }
	}
}
</script>

<style scoped>
.input{position:relative;}
</style>


// WEBPACK FOOTER //
// src/components/form/input-select.vue